import React from "react";
import EducationDetailsView from "./view";

const EducationDetailsPage = () => {
  return <EducationDetailsView />;
};

export default EducationDetailsPage;